module.exports = __webpack_public_path__ + "static/media/upload-icon-dark.a10c75ea.svg";